var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActBotonesIconos05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3D4D00;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,460.5c-0.2,0-0.4,0-0.7,0c-112.7-0.4-204.2-92.4-203.8-205.1c0.2-54.6,21.6-105.9,60.3-144.4 c38.6-38.3,89.7-59.4,144-59.4c0.2,0,0.5,0,0.7,0C369.2,52,460.7,144,460.3,256.7c-0.2,54.6-21.6,105.9-60.4,144.4 C361.5,439.4,310.4,460.5,256,460.5z M255.9,72.8c-48.7,0-94.5,18.9-129,53.2C92.2,160.5,73,206.5,72.8,255.4 c-0.3,101,81.6,183.4,182.6,183.8c49.7,0.1,95-18.8,129.7-53.2c34.7-34.5,53.9-80.4,54.1-129.3c0.3-101-81.6-183.4-182.6-183.8 l0,0C256.4,72.8,256.1,72.8,255.9,72.8z M265.9,131.9c-7.5,0-13.6,2.6-18.8,7.8l0,0c-5.3,5.3-7.9,11.6-7.9,19.2 c0,7.5,2.5,13.8,7.9,19.1c5.3,5.3,11.5,8,19,8c0,0,0,0,0.1,0c7.5,0,13.8-2.6,19.1-7.9c5.3-5.3,7.9-11.6,7.9-19.2 c0-7.5-2.5-13.8-7.8-19.2C280.1,134.5,274.4,131.8,265.9,131.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.9,230.5l1.8,0.2h13.4l-2.4,13.3c-0.2,2.4-0.9,6.5-3,13.8c-1.7,4.8-21.5,61.9-27.8,80.7 c-5.9,17.7-0.7,31.8,2.8,36.8c10.8,15,26.6,15.1,32.6,15.1c0,0,0.1,0,0.2,0c25.5,0,49.5-21.9,58.8-53.4l-6.1-4.7 c-5.3,7.6-18.6,24.2-35.7,27.2l-4.1,1.5l-4.8-2.6c-8.3-4.5-10.1-17.7-8.8-23.6l37.3-126.9h-5.9l-72.7,14l-1.5,12.7 c2.1-0.3,5.4-0.8,11.4-1.8l5.2-0.8c3.5-0.5,6.7-1,7.9-1.2L232.9,230.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActBotonesIconos05);
export default __webpack_public_path__ + "static/media/act_botones-iconos-05.211a1b8d3f066f5d71bb7b228937c051.svg";
export { ForwardRef as ReactComponent };